/**
 * A política da senha do inscrito, para a tela marcar cada requisito enquanto
 * a pessoa digita (RN-CP-12).
 *
 * A regra de verdade é a da API (`apps/api/.../senha-do-inscrito.ts`): ela
 * confere de novo e devolve a lista do que falta, com o mesmo texto. Esta
 * cópia só existe para a pessoa não descobrir o requisito depois de enviar.
 */

import { somenteDigitos } from '../contrato';

export const TAMANHO_MINIMO_DA_SENHA = 10;
export const TAMANHO_MAXIMO_DA_SENHA = 128;

export interface RequisitoDaSenha {
  texto: string;
  cumprido: (senha: string, cpf: string) => boolean;
}

export const REQUISITOS_DA_SENHA: readonly RequisitoDaSenha[] = [
  {
    texto: `Pelo menos ${TAMANHO_MINIMO_DA_SENHA} caracteres`,
    cumprido: (senha) => senha.length >= TAMANHO_MINIMO_DA_SENHA,
  },
  { texto: 'Pelo menos uma letra', cumprido: (senha) => /\p{L}/u.test(senha) },
  { texto: 'Pelo menos um número', cumprido: (senha) => /\p{Nd}/u.test(senha) },
  {
    texto: 'Não pode conter o seu CPF',
    cumprido: (senha, cpf) => {
      const digitos = somenteDigitos(cpf);
      return digitos.length !== 11 || !somenteDigitos(senha).includes(digitos);
    },
  },
];

export function senhaAtendeAPolitica(senha: string, cpf: string): boolean {
  return (
    senha.length <= TAMANHO_MAXIMO_DA_SENHA &&
    REQUISITOS_DA_SENHA.every((requisito) => requisito.cumprido(senha, cpf))
  );
}
